import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import ChatMenuModal from '../../../containers/modals/chatmenu';
const translatePayload = (node) => {
    const { buttons } = node.payload;
    return Object.entries(buttons)
        .sort(([, a], [, b]) => { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0); })
        .map(([key, { nodeId }]) => ({
        id: uuid(),
        label: key,
        connection: nodeId || uuid(),
    }));
};
const updateConnection = (node, connection, connectionId) => {
    const { payload } = node;
    const buttons = Object.assign({}, payload.buttons);
    const label = connection.connectionLabel;
    if (label && buttons[label]) {
        buttons[label] = Object.assign(Object.assign({}, buttons[label]), { nodeId: connectionId });
    }
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { buttons }) });
};
export const ChatMenuNodeAttributes = {
    iconName: 'channels',
    label: 'Menu',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: ChatMenuNode,
    ActionModal: ChatMenuModal,
};
export function ChatMenuNode({ node }) {
    const { payload } = node;
    const { buttons } = payload;
    const optionCount = Object.keys(buttons).length;
    const optionText = optionCount === 1 ? 'Option' : 'Options';
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: `${optionCount} ${optionText}` }) })), [optionCount, optionText]) }));
}
